import { atom } from 'recoil';

import { ClientFlowAction } from '~/graphql/types.client';
import { type FlowV2 } from '~/graphql/types';

export type InitialFlow = {
  flowName: FlowV2['name'];
  flowDescription: FlowV2['description'];
  enabled: FlowV2['enabled'];
  maximumFlowRun: FlowV2['maximumFlowRun'];
  actions: Array<ClientFlowAction>;
};

export const initialFlowState = atom<InitialFlow | null>({
  key: 'initialFlow',
  default: null,
});

/**
 * Disables the flow canvas interactions while the builder is saving.
 * Kept in shared Automation flow state so both builders can reuse it.
 */
export const flowDisabledState = atom<boolean>({
  key: 'automationV2/flowDisabled',
  default: false,
});
